export enum Account {
    Ja = 'ja',
    Nee = 'nee',
}
